export default __webpack_public_path__ + "static/zamazon-comics-31f3dcd6527bd10fc7aa554cb9d0fdec.pdf";